<div class="loader-overlay" *ngIf="apiService.ShowSpinner">
  <div class="spinner-container">
    <mat-spinner diameter="32" color="accent"></mat-spinner>
  </div>
</div>
<router-outlet></router-outlet>
